import React from "react"

import ScheduleView from "../schedule/ScheduleView"

interface InternalScheduleContentProps {
  selectedDate: Date
  onSelectedDateChange: (date: Date) => void
}

const InternalScheduleContent: React.FC<InternalScheduleContentProps> = ({
  selectedDate,
  onSelectedDateChange,
}) => {
  return (
    <ScheduleView
      scheduleType="internal"
      selectedDate={selectedDate}
      onSelectedDateChange={onSelectedDateChange}
    />
  )
}

export default InternalScheduleContent
